/**
 * Quick setup (section `quick`): heading + essentials card + smart defaults.
 * Free vs paid is chosen on the event-type picker and does not switch inside the builder.
 */

import React from "react";

import Icon from "../../ui/Icon";
import { useBuilder } from "../../state/builderContext";
import { COPY, SECTIONS } from "../../state/constants";
import { essentialsCount, isPaid } from "../../state/selectors";
import { AvailabilityBlock, ColorBlock, DurationBlock, EventNameBlock, FormatBlock, LocationBlock } from "./SetupBlocks";
import PaymentBlock from "./PaymentBlock";
import SmartDefaults from "./SmartDefaults";

const QuickSetup = () => {
  const { state } = useBuilder();
  const paid = isPaid(state);
  const title = state.meta.isNew
    ? paid
      ? "Create a paid event in under a minute"
      : "Create an event in under a minute"
    : `Edit ${(state.type.event_name || "").trim() || "event"}`;

  return (
    <>
      <div className="eb-builder-heading">
        <div>
          <span className={`eb-step-chip ${paid ? "paid-chip" : ""}`.trim()}>
            <Icon name="sparkle" size={14} /> {paid ? "Paid event" : COPY.sections[SECTIONS.QUICK]}
          </span>
          <h1>{title}</h1>
          <p>Confirm the essentials. MeetOcto will take care of the rest.</p>
        </div>
        <div className="eb-heading-tools">
          <span className="eb-chip">{paid ? "Paid event" : "Free event"}</span>
          <span className="eb-required-note">{essentialsCount(state)} essentials</span>
        </div>
      </div>

      <div className="eb-setup-layout">
        <section className="eb-setup-card">
          <EventNameBlock n={1} />
          <FormatBlock n={2} />
          <DurationBlock n={3} />
          <LocationBlock n={4} />
          <AvailabilityBlock n={5} />
          <ColorBlock n={6} />
          {paid ? <PaymentBlock n={7} /> : null}
        </section>
        <SmartDefaults />
      </div>
    </>
  );
};

export default QuickSetup;
